import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { Option } from '../../../components/Form/Inputs/AutocompleteInput'
import NotificationType from '../../types/enums/NotificationType'
import { NotificationReason } from '../../types/enums/NotificationReason'

export interface SettingsState {
  hideSchedule: boolean
  remoteWorkMode: boolean
  defaultProject: Option | null
  defaultWorkingHours?: { start: string; end: string }
  workHourCollapseThreshold: number
  workHoursSortByFavorite: boolean
  notificationType: NotificationType
  mutedNotificationReasons: NotificationReason[]
}

const initialState: SettingsState = {
  hideSchedule: false,
  remoteWorkMode: false,
  defaultProject: null,
  defaultWorkingHours: undefined,
  workHourCollapseThreshold: 0,
  workHoursSortByFavorite: false,
  notificationType: NotificationType.PUSH,
  mutedNotificationReasons: []
}

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSettings: (state, action: PayloadAction<SettingsState>) => {
      state.defaultProject = action.payload.defaultProject
      state.remoteWorkMode = action.payload.remoteWorkMode
      state.hideSchedule = action.payload.hideSchedule
      state.defaultWorkingHours = action.payload.defaultWorkingHours
      state.workHourCollapseThreshold = action.payload.workHourCollapseThreshold
      state.workHoursSortByFavorite = action.payload.workHoursSortByFavorite
      state.notificationType = action.payload.notificationType
      state.mutedNotificationReasons = action.payload.mutedNotificationReasons
    },
  },
})

export const getCurrentHideSchedule = (state: RootState) => state.settings.hideSchedule
export const getCurrentRemoteWorkMode = (state: RootState) => state.settings.remoteWorkMode
export const getCurrentDefaultProject = (state: RootState) => state.settings.defaultProject
export const getWorkHourCollapseThreshold = (state: RootState) => state.settings.workHourCollapseThreshold
export const getWorkHoursSortByFavorite = (state: RootState) => state.settings.workHoursSortByFavorite
export const getSettings = (state: RootState) => state.settings
export const getMutedNotificationReasons = (state: RootState) => state.settings.mutedNotificationReasons

export const { setSettings } = settingsSlice.actions
export const settingsReducer = settingsSlice.reducer

export default settingsReducer